import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { MapsService } from './services/maps.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [MapsService, GoogleAnalyticsService],
})
export class GoogleModule {}
